module.exports = __webpack_public_path__ + "img/why-pdf.595f604a.jpg";